window.SMTX.MainNav  = (function(){

  var $_window = $(window);
  var $_mainNav = $('.top-menu');
  var $_mobileBottomBar = $('.mobile-bottom-bar');
  var FIXED_TRIGGER_Y = 2;
  var MOBILE_BOTTOM_BAR_Y = 100;

  if ($('#global_alerts ').length > 0) {
    $('#global_alerts .callout').each(function(){
      if(!$(this).hasClass('hide')){
        FIXED_TRIGGER_Y = 2;
        $_mainNav.addClass('has-alert');
      }
    });
  }
  // mobile/tablet toggle
 
  $(document).on('click', '[data-open-menu]', function(e){
    e.preventDefault();
    e.stopPropagation();
    
    // Remove other active menus
    if($(this).hasClass('has-opened-menu')) {
      $('[data-open-menu]').removeClass('has-opened-menu');
    } else {
      $('[data-open-menu]').removeClass('has-opened-menu');
      $(this).addClass('has-opened-menu');
    }
    
    // Open this menu
    toggleMenu($(this).parents('.menu-double-col'), $(this).data('open-menu'));
  })
  
  function toggleMenu($menu, $menuId) {
    
    // Toggle menu off if already visible
    if($(`[data-menu-id="${$menuId}"]`, $menu).hasClass('show')) {
      $($menu).removeClass('showRightCol');
      $(`[data-menu-id="${$menuId}"]`, $menu).removeClass('show');
    } else {
      $($menu).addClass('showRightCol');
      $(`[data-menu-id`, $menu).removeClass('show');
      $(`[data-menu-id="${$menuId}"]`, $menu).addClass('show')
    }
  }
  
  $(document).on('click', ".burger-button", function() {
    var $me = $(this);
    $me.toggleClass('is-open');

    if( $me.hasClass('is-open') ){
      openMainNav();
    }else{
      closeMainNav();
    }
  });

  function openMainNav(){
    $('body').addClass('nav-open');
  }

  function closeMainNav(){
    $('body').removeClass('nav-open');
  }

  // fixed nav
  $_window.on('scroll resize', onScrollStickyNav ).trigger('scroll');

  function onScrollStickyNav(){
    if( $_window.scrollTop() >= FIXED_TRIGGER_Y ){
      $_mainNav.addClass('is-fixed');
      //hideDownButton();
    }else{
      $_mainNav.removeClass('is-fixed');
      //showDownButton();
    }

    if($_mobileBottomBar.length > 0){
      if( $_window.scrollTop() >= MOBILE_BOTTOM_BAR_Y){
        $_mobileBottomBar.addClass('hidden');
      }else{
        $_mobileBottomBar.removeClass('hidden');
      }
    }
  }

  $( ".lang-picker select" ).change(function() {
    var $me = $(this);
    $('.lang-picker .selected').text($me.find('option:selected').text());
    window.location.href = $me.val();
  });

  $('.dropdown.main-nav').on('show.zf.dropdownMenu', function(e, $el){
    resetMenu();
  });
  
  $('.dropdown.main-nav').on('hide.zf.dropdownMenu', function(e, $el){
    resetMenu()
  });
  
  function resetMenu() {
    $('[data-open-menu]').removeClass('has-opened-menu');
    $('.showRightCol').removeClass('showRightCol');
    $(`[data-menu-id]`).removeClass('show');
  }
 

  return {};

})();
